const BACKGROUND_COLOR = "BACKGROUND_COLOR";
const FOREGROUND_COLOR = "FOREGROUND_COLOR";

export { BACKGROUND_COLOR, FOREGROUND_COLOR };
//# sourceMappingURL=dataHooks.js.map
